import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import translationEN from './locales/en.json';
import translationAR from './locales/ar.json';
import { getInitialLanguage } from './languagePreference';

const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: 'ar',
  interpolation: {
    escapeValue: false, // React already escapes by default
  },
});

export default i18n;
